export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message)
    this.name = 'ApiError'
  }
}

export function useMockApi(): boolean {
  if (import.meta.env.VITE_USE_MOCK_API === 'false') return false
  if (import.meta.env.VITE_USE_MOCK_SESSIONS === 'false') return false
  return true
}

export async function apiFetch<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json')
  }

  const response = await fetch(path, {
    ...init,
    headers,
    credentials: 'include',
  })

  if (response.status === 401) {
    throw new ApiError('unauthorized', 401)
  }

  if (!response.ok) {
    let code: string | undefined
    try {
      const body = (await response.json()) as { error?: string }
      code = body.error
    } catch {
      // ignore parse errors
    }

    throw new ApiError(code ?? `http_${response.status}`, response.status, code)
  }

  if (response.status === 204) {
    return undefined as T
  }

  return (await response.json()) as T
}

export async function apiFetchNullable<T>(path: string, init: RequestInit = {}): Promise<T | null> {
  const response = await fetch(path, {
    ...init,
    credentials: 'include',
  })

  if (response.status === 404) return null
  if (response.status === 401) throw new ApiError('unauthorized', 401)

  if (!response.ok) {
    throw new ApiError(`http_${response.status}`, response.status)
  }

  return (await response.json()) as T
}
